import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MetafrenzyGuard } from 'ngx-metafrenzy';
import { AboutComponent } from './about.component';
import { IntroComponent } from './intro/intro.component';
import { PrivacyComponent } from './privacy/privacy.component';
import { TermsComponent } from './terms/terms.component';

const routes: Routes = [
  {
    path: '',
    component: AboutComponent,
    canActivateChild: [MetafrenzyGuard],
    children: [
      {
        path: '',
        component: IntroComponent,
        data: {
          metafrenzy: {
            title: $localize`:@@metaDataAboutTitle:What is Wipperoz? What do we do? Learn about us, our mission, vision and values`,
            tags: [
              {
                name: 'description',
                content: $localize`:@@metaDataAboutDescription:Wipperoz is the free and reliable services platform, we connect the need with the solution, the professional with the customer. Be part of the community`
              },
              {
                name: 'og:title',
                content: $localize`:@@metaDataAboutOgTitle:What is Wipperoz? What do we do? Learn about us, our mission, vision and values`
              },
              {
                name: 'og:description',
                content: $localize`:@@metaDataAboutOgDescription:Wipperoz is the free and reliable services platform, we connect the need with the solution, the professional with the customer. Be part of the community`
              },
              {
                name: 'og:url',
                content: $localize`:@@metaDataAboutOgUrl:https://www.wipperoz.com/en/about`
              },
              {
                name: 'twitter:url',
                content: $localize`:@@metaDataAboutTwitterUrl:https://www.wipperoz.com/en/about`
              },
              {
                name: 'twitter:title',
                content: $localize`:@@metaDataAboutTwitterTitle:What is Wipperoz? What do we do? Learn about us, our mission, vision and values`
              },
              {
                name: 'twitter:card',
                content: 'summary'
              },
              {
                name: 'twitter:site',
                content: '@wipperoz'
              },
              {
                name: 'twitter:description',
                content: $localize`:@@metaDataAboutTwitterDescription:Wipperoz is the free and reliable services platform, we connect the need with the solution, the professional with the customer. Be part of the community`
              }
            ]
          }
        }
      },
      {
        path: 'terms',
        component: TermsComponent,
        data: {
          dataType: 'wipperoz-terms',
          metafrenzy: {
            title: $localize`:@@metaDataWipperozTermsTitle:Terms and conditions | Wipperoz`,
            tags: [
              {
                name: 'description',
                content: $localize`:@@metaDataWipperozTermsDescription:Our terms and conditions - Read our terms and conditions carefully, we know that it is boring reading but make sure you understand them and let us know if you need more information or clarification about them.`
              },
              { name: 'og:title', content: $localize`:@@metaDataWipperozTermsOgTitle:Wipperoz - Terms and Conditions` },
              {
                name: 'og:description',
                content: $localize`:@@metaDataWipperozTermsOgDescription:Our terms and conditions`
              },
              {
                name: 'og:url',
                content: $localize`:@@metaDataWipperozTermsOgUrl:https://www.wipperoz.com/en/about/terms`
              },
              {
                name: 'twitter:url',
                content: $localize`:@@metaDataWipperozTermsTwitterUrl:https://www.wipperoz.com/en/about/terms`
              },
              {
                name: 'twitter:title',
                content: $localize`:@@metaDataWipperozTermsTwitterTitle:Wipperoz - Terms and Conditions`
              },
              {
                name: 'twitter:card',
                content: 'summary'
              },
              {
                name: 'twitter:site',
                content: '@wipperoz'
              },
              {
                name: 'twitter:description',
                content: $localize`:@@metaDataWipperozTermsTwitterDescription:Our terms and conditions`
              }
            ]
          }
        }
      },
      {
        path: 'privacy',
        component: PrivacyComponent,
        data: {
          dataType: 'wipperoz-privacy',
          metafrenzy: {
            title: $localize`:@@metaDataWipperozPrivacyTitle:Privacy policy | Wipperoz`,
            tags: [
              {
                name: 'description',
                content: $localize`:@@metaDataWipperozPrivacyDescription:Our privacy policy - Read our privacy policy carefully, we know that it is boring reading but make sure you understand them and let us know if you need more information or clarification about it.`
              },
              { name: 'og:title', content: $localize`:@@metaDataWipperozPrivacyOgTitle:Wipperoz - Privacy Policy` },
              {
                name: 'og:description',
                content: $localize`:@@metaDataWipperozPrivacyOgDescription:Our privacy policy`
              },
              {
                name: 'og:url',
                content: $localize`:@@metaDataWipperozPrivacyOgUrl:https://www.wipperoz.com/en/about/privacy`
              },
              {
                name: 'twitter:url',
                content: $localize`:@@metaDataWipperozPrivacyTwitterUrl:https://www.wipperoz.com/en/about/privacy`
              },
              {
                name: 'twitter:title',
                content: $localize`:@@metaDataWipperozPrivacyTwitterTitle:Wipperoz - Privacy Policy`
              },
              {
                name: 'twitter:card',
                content: 'summary'
              },
              {
                name: 'twitter:site',
                content: '@wipperoz'
              },
              {
                name: 'twitter:description',
                content: $localize`:@@metaDataWipperozPrivacyTwitterDescription:Our privacy policy`
              }
            ]
          }
        }
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AboutRoutingModule {}
